<template>
	<article class="page-container full-width bg-white news-post single-post">
		<header class="page-header">
			<div class="thumbnail-container" :style="thumbnailStyle">
				<img :src="$options.filters.imageproxy(post.image_url, 1160)" :alt="`${post.title} - Thumbnail`">
			</div>
			<h1 class="post-title">{{ post.title }}</h1>
			<back-button fixed  :from="from"/>
		</header>

		<div class="page-content-container" v-html="$options.filters.addBlank(post.content)" />

		<section class="actions">
			<div class="action-container">
				<button type="button" class="button hollow btn-share" @click="openShareReveal">
					<font-awesome-icon :icon="['fal', 'share']" size="2x" />
				</button>
				<span class="button-text">{{ $t('buttonActions.share') }}</span>
			</div>
		</section>

		<share-reveal ref="shareReveal" id="share-reveal" :key="`share-reveal-${post.id}`" :entity="post" :share-link="shareLink" :scrape-link="scrapeLink" v-if="post && post.content" v-on:close-share-reveal="closeShareReveal" />
	</article>
</template>

<script>
	import BackButton from '@/components/BackButton.vue'
	import foundation from '@/mixins/foundation'
	import ShareReveal from '@/components/ShareReveal.vue'

	export default{
		name: 'SingleNewsPage',
		mixins: [ foundation ],
		components: {
			BackButton,
			ShareReveal
		},
		data () {
			return {
				from: null
			}
		},
		metaInfo() {
			return {
				title: this.post.title + ' | ' + this.$t('newsTitle') + ' | ' + 'Kärnten Card App',
				meta: [{
					property: 'og:title', content:  this.post.title + ' | ' + this.$t('newsTitle') + ' | ' + 'Kärnten Card App'
				}, {
					property: 'og:site_name', content: 'Kärnten Card App'
				}, {
					property: 'og:url', content: window.location.href
				}, {
					property: 'og:image', content: this.$options.filters.imageproxy(this.post.image_url, 1160)
				},{
					property: 'og:description', content: this.$options.filters.sanitized(this.post.content)
				}]
			}
		},
		beforeRouteEnter(to, from, next) {
			next((vm) => {
				vm.from = from.name;
			});
		},
		filters: {
			addBlank: (value) => {
				if (!value) return ''

				var content = document.createElement("div")
				content.innerHTML = value

				var links = content.getElementsByTagName("a")
				for (var i = links.length - 1; i >= 0; i--) {
					links[i].setAttribute('target', '_blank')
				}

				return content.innerHTML
			},
			sanitized: (value) => {
				if (!value) return ''
				return value.replace(/<\/?[^>]+(>|$)/g, "").substring(0, 160) + '...'
			}
		},
		computed: {
			post () {
				return this.$store.getters.getNewsByID(this.$route.params.uuid)
			},
			thumbnailStyle (){
				return {}
			},
			shareLink () {
				return window.location.href
			},
			scrapeLink () {
				return `https://app.kaerntencard.at/admin/sharer/news/${this.$route.params.uuid}`
			}
		},
		watch: {
			'$store.state.season': function () {
				this.$store.dispatch('fetchCardInfos', { lang: this.$store.state.language, season: this.$store.state.season })
					.then(() => {
						this.$store.dispatch('fetchNews', { lang: this.$store.state.language, season: this.$store.state.season })
					})
					.catch(err => console.log(err))

				this.$router.push({ name: 'news' })
			},
			'$store.state.language': function () {
				this.$store.dispatch('fetchCardInfos', { lang: this.$store.state.language, season: this.$store.state.season })
					.then(() => {
						this.$store.dispatch('fetchNews', { lang: this.$store.state.language, season: this.$store.state.season })
					})
					.catch(err => console.log(err))
				this.$router.push({ name: 'news' })
			}
		},
		methods: {
			openShareReveal() {
				this.$refs.shareReveal.$el.classList.add('is-reveal-open')
			},
			closeShareReveal () {
				this.$refs.shareReveal.$el.classList.remove('is-reveal-open')
			}
		}
	}
</script>

<style lang="scss" scoped>
	.news-post{
		.page-header{
			position: relative;
			.thumbnail-container{
				img{
					width: 100%;
					height: auto;
				}
				
			}

			.post-title{
				@include xy-gutters();
				margin-top: 1rem;
				text-align: left;
			}
		}

		section.actions{
			@include xy-gutters();
			@include flex();
			@include flex-align(center, middle);
			margin-top: 2rem;

			.action-container{
				text-align: center;
				&:not(:last-child){
					margin-right: 1.25rem
				}

				.button{
					display: block;
					width: 3.25rem;
					height: 3.25rem;
					padding: 0;
					margin: 0 auto;
					margin-bottom: rem-calc(10);
					font-size: 1rem;
					border-radius: 50%;

					&:hover{
						color: $white;
						background-color: get-color(primary);
						border-color: get-color(primary);
					}
				}
			}
		}
	}
</style>